import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateDocumentChecklistItemMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  DocumentChecklistItem,
  useDocumentChecklistsTableContext,
} from '../../../../DocumentChecklistsTableContext'
import {
  CreateDocumentChecklistItemModalBody,
  CreateDocumentChecklistItemModalValues,
} from './components/CreateDocumentChecklistItemModalBody'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<DocumentChecklistItem> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useDocumentChecklistsTableContext()
  const [createItem] = useCreateDocumentChecklistItemMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createDocumentChecklistItem: {
        documentChecklistItem: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Document Checklist Item',
    permission: Permission.CreateDocumentChecklistItem,
    modal: {
      type: 'simple',
      body: <CreateDocumentChecklistItemModalBody />,
      onOk: async ({
        name,
        placementTypeIds,
      }: CreateDocumentChecklistItemModalValues) => {
        await createItem({
          variables: {
            createDocumentChecklistItemInput: {
              projectId,
              name,
              concreteMaterialIds: placementTypeIds,
            },
          },
        })
        await refetch()
      },
    },
  }
}
